// Emoji list
var EMOJILIST = [];
EMOJILIST.push({
    title: ':-)',
    label: 'grinning',
    position: '-320px -464px'
});
EMOJILIST.push({ title: ':-D', label: 'smiley', position: '-368px -464px' });
EMOJILIST.push({ title: ';-)', label: 'wink', position: '-464px -464px' });
EMOJILIST.push({ title: '}-)', label: 'imp', position: '-336px -368px' });
EMOJILIST.push({
    title: ':-O',
    label: 'open mouth',
    position: '-96px -480px'
});
EMOJILIST.push({
    title: ':-\\',
    label: 'confused',
    position: '-480px -176px'
});
EMOJILIST.push({
    title: 'X-(',
    label: 'weary',
    position: '-16px -480px'
});
EMOJILIST.push({
    title: ':-(',
    label: 'disappointed',
    position: '-480px -320px'
});
EMOJILIST.push({
    title: 'B-)',
    label: 'face with sunglasses',
    position: '-480px -64px'
});
EMOJILIST.push({
    title: ':-P',
    label: 'stuck out tongue',
    position: '-480px -272px'
});
EMOJILIST.push({ title: ':-@', label: 'angry', position: '-480px -352px' });
EMOJILIST.push({
    title: ':-|',
    label: 'neutral face',
    position: '-480px -96px'
});
export default EMOJILIST;
